// Google Analytics
import ReactGA from 'react-ga';

// flag to enable/disable tracking
import { TRACK_USAGE } from './config';
// singleton instance
let tracker = {
  init: function() {
    // Google Analytics - Universal Analytics User ID
    ReactGA.initialize('UA-2003478-16');
  },

  // log the current browser location as page view
  logPageView: function() {
	  if (!TRACK_USAGE) return;
    //ReactGA.set({ page: window.location.pathname + window.location.search });
    ReactGA.pageview(window.location.pathname + window.location.search);
  },

  // log an event. Note: uses custom dimensions (https://support.google.com/analytics/answer/2709828?hl=en)
  logEvent: function(userId,clientId,category,action,label,value) {
    if (!TRACK_USAGE) return;
    ReactGA.set({
      dimension1: userId,
      dimension2: clientId
    });
    ReactGA.event({
      category: category,
      action: action,
      label: label,
      value: value,
      nonInteraction: true
    });
  }

};

export default tracker;



// WEBPACK FOOTER //
// ./src/actions/tracking.js